import tw from 'tailwind.macro';
import React from 'react';
import styled from 'styled-components';

const SocialContainer = styled.section`
  ${tw`flex flex-wrap items-center justify-center sm:justify-start mt-8`};
`;

const Button = styled("a")`
  ${tw`cursor-pointer text-sm md:text-base mx-2 sm:mx-0 py-2 px-4 md:px-8 rounded-full no-underline shadow-md focus:outline-none focus:shadow-outline`};
  transition: all 0.3s ease-in-out;
  color: white !important;
  &:hover {
    transform: translateY(-3px);
    background-color: #f8c9a8;
    transition: all 0.3s;
    color: #2f2f2f !important;
  }
`;

// @ts-ignore
const Mail = styled(Button)`
  ${tw`bg-red text-white`};
`;

const GitHub = styled(Button)`
  ${tw`bg-grey-dark text-white sm:mx-4 my-4 sm:my-0`};
`;

const LinkedIn = styled(Button)`
  ${tw`bg-blue text-white`};
`;

const Twitter = styled(Button)`
  ${tw`bg-purple-dark text-white sm:mx-4 my-4 sm:my-0`};
`;

const Devpost = styled(Button)`
  ${tw`bg-green text-white`};
`;

const Devto = styled(Button)`
  ${tw`bg-black text-white sm:mx-4 my-4 sm:my-0`};
`;

const Social = () => (
  <SocialContainer>
    <Mail role="button" target="_blank" href="mailto:chow.kartik@gmail.com">
      Mail
    </Mail>
    <GitHub role="button" target="_blank" href="https://github.com/kartikcho">
      GitHub
    </GitHub>
    <LinkedIn
      role="button"
      target="_blank"
      href="https://www.linkedin.com/in/kartikcho/"
    >
      LinkedIn
    </LinkedIn>
    <Twitter
      role="button"
      target="_blank"
      href="https://twitter.com/kartikchow"
    >
      Twitter
    </Twitter>
    <Devpost role="button" target="_blank" href="https://devpost.com/kartikcho">
      Devpost
    </Devpost>
    <Devto role="button" target="_blank" href="https://dev.to/kartikcho">
      Blog
    </Devto>
  </SocialContainer>
);

export default Social;
